const UabLogo = () => {
  return (
    <svg
      aria-label="UAB logo"
      className="uab-logo"
      viewBox="0 0 190 53.53"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          fill="#1a5632"
          d="M49.29,48.03c5.62,0,10.96-5.42,10.96-10.89,0-1.67,0-37.02,0-37.02h-16.68v29.72c0,1.19-1.31,3.6-3.62,3.6h-19.64c-2.31,0-3.62-2.41-3.62-3.6V.12H0s0,35.8,0,37.02C0,42.61,5.34,48.03,10.96,48.03h38.34Z"
        />
        <path
          fill="#1a5632"
          d="M102.36.12h-19.16l-26.35,47.9h19.54l3.63-7.46h25.5l3.63,7.46h19.54L102.36.12ZM86.44,27.37l6.33-13.02,6.33,13.02h-12.67Z"
        />
        <path
          fill="#1a5632"
          d="M129.7.19h43.01c9.78,0,14.14,4.29,14.14,11.93,0,4.22-2.08,7.91-5.7,9.31v.13c6.16,1.61,8.17,7.37,8.17,10.92,0,9.38-4.69,15.54-18.69,15.54h-40.94V.19ZM148.19,18.01h14.27c3.82,0,4.69-1.27,4.69-3.15,0-1.74-.87-3.01-4.69-3.01h-14.27v6.16ZM148.19,36.37h16.15c3.75,0,4.89-1.61,4.89-3.75s-1.14-3.75-4.89-3.75h-16.15v7.5Z"
        />
      </g>
      <path
        fill="#231f20"
        d="M503.35,44.31c1.08,0,1.95.88,1.95,1.95s-.88,1.95-1.95,1.95-1.95-.88-1.95-1.95.88-1.95,1.95-1.95ZM503.35,47.94c.92,0,1.67-.75,1.67-1.67s-.75-1.67-1.67-1.67-1.67.75-1.67,1.67.75,1.67,1.67,1.67ZM502.93,47.38h-.28v-2.25h.87c.51,0,.71.22.71.62s-.26.59-.57.64l.67.99h-.32l-.67-.99h-.4v.99ZM502.93,46.15h.36c.31,0,.65-.02.65-.39,0-.29-.26-.37-.5-.37h-.5v.76Z"
      />
    </svg>
  );
};

export default UabLogo;
